import {useMutation, useQueryClient} from "@tanstack/react-query";
import {RECOMMENDATION_ENDPOINTS} from "../../services/network/endpoints";
import {CreateRecommendationRequest} from "../../services/models/recommendation";
import {RecommendationsApi} from "../../services/network/recommendation-api";
import {toast} from "react-toastify";

interface CreateRecomParams {
    data: CreateRecommendationRequest;
}

export function useCreateRecom() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [RECOMMENDATION_ENDPOINTS.CREATE],
        mutationFn: async ({data}: CreateRecomParams) => {
            return RecommendationsApi.createRecommendation(data);
        },
        onError() {
            toast.error("Ошибка при создании рекомендации");
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({queryKey: [RECOMMENDATION_ENDPOINTS.FETCH_BY_SECTOR, variables.data.sector]});
            toast.success("Рекомендация успешно создана");
        }
    });
}